module.exports = __webpack_public_path__ + "static/media/property-wise.cb19358b.png";